/**
 * West Coast Deals - Theme JavaScript
 * Refined Edition
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ========================================
  // Mobile Menu
  // ========================================
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mainNavigation = document.querySelector('#mainNavigation');
  const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');
  
  function closeMobileMenu() {
    document.body.classList.remove('menu-open');
    if (mobileMenuToggle) {
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
    if (mobileMenuOverlay) {
      mobileMenuOverlay.classList.remove('active');
    }
  }
  
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function() {
      const isOpen = document.body.classList.toggle('menu-open');
      mobileMenuToggle.setAttribute('aria-expanded', isOpen);
      
      if (isOpen) {
        document.body.style.overflow = 'hidden';
        if (mobileMenuOverlay) {
          mobileMenuOverlay.classList.add('active');
        }
      } else {
        document.body.style.overflow = '';
        if (mobileMenuOverlay) {
          mobileMenuOverlay.classList.remove('active');
        }
      }
    });
  }
  
  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', closeMobileMenu);
  }
  
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMobileMenu);
  }
  
  // Mobile search toggle
  const mobileSearchToggle = document.querySelector('.mobile-search-toggle');
  const mobileSearchBar = document.querySelector('.mobile-search-bar');
  
  if (mobileSearchToggle && mobileSearchBar) {
    mobileSearchToggle.addEventListener('click', function() {
      mobileSearchBar.classList.toggle('active');
    });
  }
  
  // Mobile dropdown menu handling
  const dropdownItems = document.querySelectorAll('.has-dropdown');
  dropdownItems.forEach(item => {
    const link = item.querySelector('.nav-link');
    if (link) {
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          e.stopPropagation();
          item.classList.toggle('active');
          return false;
        }
      });
    }
  });
  
  // Handle clicks on child links within dropdowns
  const megaMenuLinks = document.querySelectorAll('.mega-menu a');
  megaMenuLinks.forEach(link => {
    link.addEventListener('click', function() {
      if (window.innerWidth <= 768) {
        closeMobileMenu();
      }
    });
  });
  
  // Close mobile menu on window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth > 768) {
      closeMobileMenu();
    }
  });

  // ========================================
  // Sticky Header
  // ========================================
  const header = document.querySelector('.site-header');
  
  if (header) {
    const handleScroll = () => {
      const currentScroll = window.pageYOffset || window.scrollY || document.documentElement.scrollTop;
      
      if (currentScroll > 80) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Check on load
  }

  // ========================================
  // Mega Menu (Desktop)
  // ========================================
  const megaMenuItems = document.querySelectorAll('.has-dropdown');
  
  megaMenuItems.forEach(item => {
    let timeout;
    
    item.addEventListener('mouseenter', function() {
      if (window.innerWidth > 768) {
        clearTimeout(timeout);
        const menu = this.querySelector('.mega-menu');
        if (menu) {
          menu.style.display = 'block';
        }
      }
    });
    
    item.addEventListener('mouseleave', function() {
      if (window.innerWidth > 768) {
        const menu = this.querySelector('.mega-menu');
        if (menu) {
          timeout = setTimeout(() => {
            menu.style.display = 'none';
          }, 150);
        }
      }
    });
  });

  // ========================================
  // Hero Slider
  // ========================================
  window.initHeroSlider = function() {
    let slideIndex = 1;
    let slideTimer;
    const slider = document.getElementById('heroSlider');
    
    if (!slider) return;
    
    function showSlide(n) {
      const slides = slider.getElementsByClassName("hero-slide");
      const dots = document.getElementsByClassName("hero-dot");
      
      if (slides.length === 0) return;
      
      if (n > slides.length) { slideIndex = 1; }
      if (n < 1) { slideIndex = slides.length; }
      
      for (let i = 0; i < slides.length; i++) {
        slides[i].classList.remove("active");
      }
      
      for (let i = 0; i < dots.length; i++) {
        dots[i].classList.remove("active");
      }
      
      slides[slideIndex - 1].classList.add("active");
      if (dots.length > 0) {
        dots[slideIndex - 1].classList.add("active");
      }
    }
    
    function changeSlide(n) {
      clearTimeout(slideTimer);
      showSlide(slideIndex += n);
      startAutoSlide();
    }
    
    function currentSlide(n) {
      clearTimeout(slideTimer);
      showSlide(slideIndex = n);
      startAutoSlide();
    }
    
    function startAutoSlide() {
      const slides = slider.getElementsByClassName("hero-slide");
      if (slides.length > 1) {
        slideTimer = setTimeout(function() {
          changeSlide(1);
        }, 5000);
      }
    }
    
    // Make functions globally available
    window.changeSlide = changeSlide;
    window.currentSlide = currentSlide;
    
    // Initialize
    showSlide(slideIndex);
    startAutoSlide();
  };
  
  if (document.getElementById('heroSlider')) {
    window.initHeroSlider();
  }

  // ========================================
  // Search Input Typewriter
  // ========================================
  const searchInput = document.getElementById('header-search-input');
  if (searchInput) {
    const searchExamples = [
      'adidas samba',
      'adizero evo',
      'running shoes',
      'adidas sneakers',
      'handball spezial',
      'adidas campus',
      'nike air force',
      'vans sk8 low'
    ];
    
    let currentWordIndex = 0;
    let currentCharIndex = 0;
    let isDeleting = false;
    let typewriterInterval = null;
    
    function typeWriter() {
      const currentWord = searchExamples[currentWordIndex];
      
      if (!isDeleting && currentCharIndex < currentWord.length) {
        searchInput.placeholder = currentWord.substring(0, currentCharIndex + 1);
        currentCharIndex++;
        typewriterInterval = setTimeout(typeWriter, 100);
      } else if (!isDeleting && currentCharIndex === currentWord.length) {
        isDeleting = true;
        typewriterInterval = setTimeout(typeWriter, 2500);
      } else if (isDeleting && currentCharIndex > 0) {
        currentCharIndex--;
        searchInput.placeholder = currentWord.substring(0, currentCharIndex);
        typewriterInterval = setTimeout(typeWriter, 50);
      } else if (isDeleting && currentCharIndex === 0) {
        isDeleting = false;
        currentWordIndex = (currentWordIndex + 1) % searchExamples.length;
        typewriterInterval = setTimeout(typeWriter, 500);
      }
    }
    
    typeWriter();
    
    searchInput.addEventListener('focus', function() {
      if (typewriterInterval) {
        clearTimeout(typewriterInterval);
        typewriterInterval = null;
      }
      if (!this.dataset.originalPlaceholder) {
        this.dataset.originalPlaceholder = this.placeholder || 'Search for shoes, clothes, etc.';
      }
      this.placeholder = this.dataset.originalPlaceholder;
    });
    
    searchInput.addEventListener('blur', function() {
      if (this.value === '') {
        currentWordIndex = 0;
        currentCharIndex = 0;
        isDeleting = false;
        typeWriter();
      }
    });
  }

  // ========================================
  // Global Cart Update Function
  // ========================================
  window.updateCartCount = function() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountElements = document.querySelectorAll('.cart-count');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
          el.classList.add('bump');
          setTimeout(() => el.classList.remove('bump'), 400);
        });
        return cart;
      })
      .catch(error => console.error('Error updating cart:', error));
  };

});

// ========================================
// Money Formatter
// ========================================
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
